.uiOverlay {
  /* Isolate the stacking context so that the UI is always on top of the 3D labels. */
  position: relative;

  pointer-events: none;
}

.uiOverlay > * {
  pointer-events: initial;
}

.menuBar {
  width: max-content;
  margin-left: auto;
}

.tabButton {
  padding: 0;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;

  width: 2.5rem;
  height: 2.5rem;
  vertical-align: middle;
}

.tabButton[aria-selected="true"] {
  background-color: #a6a6a63c;
  backdrop-filter: blur(2px);
}
